module.exports = __webpack_public_path__ + "static/WIIBPhone3-a0b55ec277d38eb2307c2857824e2fee.svg";